import script from "./RecoverPassword.vue?vue&type=script&setup=true&lang=js"
export * from "./RecoverPassword.vue?vue&type=script&setup=true&lang=js"

import "./RecoverPassword.vue?vue&type=style&index=0&id=13db3720&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13db3720"]])

export default __exports__